/**
 * Expanded group members section — composes the student and teacher subsections.
 */

import { GroupStudents } from './group-students';
import { GroupTeachers } from './group-teachers';

interface GroupMembersProps {
  groupId: string;
}

export function GroupMembers({ groupId }: GroupMembersProps) {
  return (
    <div className="mt-3 border-t border-stone-200 pt-3 dark:border-stone-700">
      <GroupStudents groupId={groupId} />
      <GroupTeachers groupId={groupId} />
    </div>
  );
}
